import React, { useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'
import { Button, Input } from 'antd'
import * as api from '../../../api/pgads'
import CommonScreen from '../CommonScreen'

const title = 'Message Category'

const MessageCategory = () => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <div
      style={{
        width: '100%',
        display: 'flex',
      }}
    >
      <div
        style={{
          width: '100px',
          display: 'grid',
          alignContent: 'center',
          marginLeft: '20px',
        }}
      >
        Category :{' '}
      </div>
      <Input
        style={{ width: '200px' }}
        value={insertData.category}
        onChange={e =>
          setInsertData({ ...insertData, category: e.target.value })
        }
        maxLength={15}
      />
      <Button
        type="primary"
        style={{ marginLeft: '50px' }}
        onClick={() => onAdd(true)}
      >
        Add
      </Button>
      <Button
        type="primary"
        style={{ marginLeft: '50px' }}
        onClick={() => onAdd(false)}
      >
        Add & Hide
      </Button>
      <Button type="danger" style={{ marginLeft: '50px' }} onClick={onCancel}>
        Cancel
      </Button>
    </div>
  )

  return (
    <CommonScreen
      withUnitSelection={false}
      isAdminScreen
      title={title}
      header={MessageCategoryHeaders}
      saveTask={api.saveMessageCategory}
      retrieveTask={api.getMessageCategory}
      deleteTask={api.deleteMessageCategory}
      altBy={d => d.unitId}
      autoRetrieve
      sortOptions={MessageCategoryHeaders}
      widthOffset={100}
      heightOffset={270}
      insertComp={insertEvent && insertComp}
      onInsertEvent={b => setInsertEvent(b)}
      insertCompHeight={0}
      autoFixColByKey={false}
      headerRowHeight={60}
    />
  )
}

export default MessageCategory

export const MessageCategoryHeaders = [
  strCol({
    ident: 'category',
    display: 'Category',
    isKey: true,
    width: 200,
    alignment: 'left',
  }),
]
